import { render, staticRenderFns } from "./u-header-search-outlined-pill.vue?vue&type=template&id=01b177ce&scoped=true"
import script from "./u-header-search-outlined-pill.vue?vue&type=script&lang=js"
export * from "./u-header-search-outlined-pill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b177ce",
  null
  
)

export default component.exports